/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import isValidDate from '../../../../../../shared/utils/isValidDate';
import PREDEFINED_INTERVALS from '../../../../../../shared/constants/predefinedIntervals';
import AdvancedDatePicker from './components/AdvancedDatePicker/AdvancedDatePicker';
import DateTimePicker from '../../../../../../shared/ui/DateTimePicker/DateTimePicker';
import Wrapper from './styles/Wrapper';
import { getIntervalValue, getRegularIntervalValues } from '../../utils';
import SingleSelect from '../../../../../../shared/ui/SingleSelect';
import Container from './styles/Container';
import { getScheduledIntervalValues } from '../../utils/createControlForParam';

function IntervalComponent(props) {
  const {
    label,
    value: [valueFrom, valueTo],
    intervalName,
    required,
    id,
    onChange,
    dateOnly,
    isSchedule,
  } = props;

  const [selectedInterval, setSelectedInterval] = useState(intervalName);
  const [from, setFrom] = useState(valueFrom);
  const [to, setTo] = useState(valueTo);
  const [fromError, setFromError] = useState(false);
  const [toError, setToError] = useState(false);

  useEffect(() => {
    const newInterval = getIntervalValue(from, to, fromError, toError, isSchedule);

    onChange(id, newInterval, { intervalName: selectedInterval });
  }, [from, to, fromError, toError, selectedInterval, isSchedule]);

  useEffect(() => {
    if (isSchedule) {
      const scheduled = getScheduledIntervalValues(selectedInterval);
      if (scheduled) {
        setFrom(scheduled[0]);
        setTo(scheduled[1]);
      }
    } else {
      const regular = getRegularIntervalValues(selectedInterval, dateOnly);
      if (regular) {
        setFrom(new Date(regular[0]));
        setTo(new Date(regular[1]));
        setFromError(false);
        setToError(false);
      }
    }
  }, [selectedInterval, isSchedule, dateOnly, valueFrom, valueTo]);

  const handleFromChange = (newValue) => {
    if (isSchedule) {
      setSelectedInterval(PREDEFINED_INTERVALS.CUSTOM);
      setFrom(newValue);
    } else if (newValue && !isValidDate(new Date(newValue))) {
      setFromError(true);
    } else {
      setFromError(false);
      setSelectedInterval(PREDEFINED_INTERVALS.CUSTOM);
      setFrom(newValue);
    }
  };

  const handleToChange = (newValue) => {
    if (isSchedule) {
      setSelectedInterval(PREDEFINED_INTERVALS.CUSTOM);
      setTo(newValue);
    } else if (newValue && !isValidDate(new Date(newValue))) {
      setToError(true);
    } else {
      setToError(false);
      setSelectedInterval(PREDEFINED_INTERVALS.CUSTOM);
      setTo(newValue);
    }
  };

  const intervalOptions = [
    { value: PREDEFINED_INTERVALS.TODAY, name: 'Сегодня' },
    { value: PREDEFINED_INTERVALS.YESTERDAY, name: 'Вчера' },
    ...(!dateOnly ? [{ value: PREDEFINED_INTERVALS.DAY, name: 'Сутки' }] : []),
    { value: PREDEFINED_INTERVALS.WEEK, name: 'Неделя' },
    { value: PREDEFINED_INTERVALS.CURRENT_MONTH, name: 'Текущий месяц' },
    { value: PREDEFINED_INTERVALS.LAST_MONTH, name: 'Прошедший месяц' },
    { value: PREDEFINED_INTERVALS.CUSTOM, name: 'Выбранный период' },
  ];

  const DateInput = isSchedule ? AdvancedDatePicker : DateTimePicker;

  return (
    <Container>
      <SingleSelect
        value={selectedInterval}
        items={intervalOptions}
        onChange={(e) => setSelectedInterval(e.target.value)}
        label={label}
        name="interval-select"
      />

      <Wrapper>
        <DateInput
          label="C"
          value={from}
          onChange={handleFromChange}
          maxDateTime={to}
          maxDate={to}
          name={id}
          required={required}
          error={fromError}
          dateOnly={dateOnly}
          allowExpressions={isSchedule}
        />
      </Wrapper>
      <Wrapper>
        <DateInput
          label="По"
          value={to}
          minDateTime={from}
          minDate={from}
          name={id}
          onChange={handleToChange}
          required={required}
          error={toError}
          dateOnly={dateOnly}
          allowExpressions={isSchedule}
        />
      </Wrapper>
    </Container>
  );
}

export default IntervalComponent;
